import dom, { Fragment} from "../../dist/jsx-render/dom";
import { ComponentBase } from "./ComponentBase";
import { app } from "../Frame/App";

type RadioButtonComponentProps = {
    /** Use this option if the radioButtons map to one field on the model. */
    field?: string;

    /** if the options map the multiple fields on the model, use this option. The field has to be specified in
     * the radioButtonOption object. The fields can be of type boolean oder number. */
    multiFieldMapping?: boolean;

    /** Set a model here if the radio button options map directly to one or more fields of the given model. It can be used without a model.
     * In that case, only the external change handler is called and no values are set directly.
     */
    model?: any;
    name: string;
    description?: string;

    changeEvent?: (event: Event) => void;

    inline: boolean;

    options: RadioButtonOption[];

    /** Set to true, if the underlying field is a boolean property. Default: false. */
    isBoolean?: boolean;

    /** Set to true, if multiFieldMapping is for string fields. Default: false. */
    isMultiFieldMappingForStringValues?: boolean;

    additionalCssClasses?: string;

    /** To not create a form group, set to false. */
    createFormGroup?: boolean;

    defaultValue?: string;
}

export class RadioButtonComponent extends ComponentBase {
    constructor(props: RadioButtonComponentProps) { super(props); }
    props: RadioButtonComponentProps;

    clientId: string = app.createGuid();

    formGroup: HTMLElement = <div className={"form-group" + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")}>
     
    </div>;

    protected handleChange = (event: Event) => {
        if (this.props.field) {
            this.updateModelFromControl((event.target as HTMLInputElement).value, this.props.field, this.props.model);
        } else if (this.props.multiFieldMapping) {
            const value = (event.target as HTMLInputElement).value;

            // Get the selected option using the value
            let foundOptions = this.props.options.filter(o => o.value == Number(value));
            if (foundOptions.length > 0) {
                let field = foundOptions[0].field;

                // Update the specified field.
                this.updateModelFromControl("1", field, this.props.model);
            }

            let foundFalseOptions = this.props.options.filter(o => o.value != Number(value));
            foundFalseOptions.forEach(o => {
                this.updateModelFromControl("0", o.field, this.props.model);
            });
        }

        // Call external event handler if present.
        if (this.props.changeEvent) {
            this.props.changeEvent(event);
        }
    }

    private updateModelFromControl(value: string, field: string, model: any) {
        if (this.props.isBoolean === true) {
            model.setPropertyByPath(field, value == "1");
        } else {
            model.setPropertyByPath(field, app.anyToInt(value));
        }
    }

    private getInputElement(id: string, value: string, selected: boolean) {
        if (selected === true) {
            return <input class={"form-check-input"
                + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")
                + ` value-${value}`}
                type="radio" id={"radio_" + id} value={value} name={this.props.name + id} checked />
        } else {
            return <input class={"form-check-input"
                + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")
            + ` value-${value}`}
                type="radio" id={"radio_" + id} value={value} name={this.props.name + id} />
        }
    }

    render() {
        let selectedValue: any;
        if (this.props.field) {
            selectedValue = this.props.model.getPropertyByPath(this.props.field);
        } else if (this.props.multiFieldMapping) {

            for (let o of this.props.options) {
                let value = this.props.model.getPropertyByPath(o.field);

                if (this.props.isBoolean) {
                    if (value === true) {
                        selectedValue = o.value;
                        break;
                    }
                } else if (this.props.isMultiFieldMappingForStringValues) {
                    if (value && value != "0") {
                        selectedValue = o.value;
                        break;
                    }
                } else {
                    if (value == 1) {
                        selectedValue = o.value;
                    }
                    break;
                }
            }
        }
        //else {
        //    console.log("Either field or multipleFieldMapping must be set.");
        //    return <div className="Error">Error: check props of RadioButtonComponent</div>
        //}

        if ((selectedValue == null || selectedValue == undefined) && this.props.defaultValue) {
            selectedValue = this.props.defaultValue;
        }

        let element = <div>
            {this.props.name ? <div><label className="form-label">{this.props.name}</label></div> : []}
            {this.props.options.map(o => {
                let inputElement: HTMLInputElement =
                    this.getInputElement(this.clientId,
                        o.value.toString(),
                        (o.value === selectedValue || o.value == app.anyToInt(selectedValue)),
                    )

                inputElement.addEventListener('change', this.handleChange);

                return <div class={"form-check" + (this.props.inline ? " form-check-inline" : "")}>
                    {inputElement}
                    <label class="form-check-label" for={"radio_" + this.clientId}>{o.description}</label>
                </div>
            })}
        </div>

        if (this.props.createFormGroup !== false) {
            (element as HTMLElement).classList.add("form-group");
        }

        //if (this.props.model[this.props.field] == null || this.props.model[this.props.field] == undefined) {

        //}

        return (element);
        
    }

    dispose() { }
    validate() { }
}

export class RadioButtonOption {
    description: string;
    value: number;
    field?: string;
}